import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import Home from './Home';
import { ChildContext } from './context';

const Iform = ({
  params, languageData, locale, formDocument,
}) => (
  <IntlProvider locale={locale} messages={languageData}>
    <ChildContext.Provider value={params}>
      <Home
        formDocument={formDocument}
      />
    </ChildContext.Provider>
  </IntlProvider>
);

export const TestableIform = Iform;

Iform.propTypes = {
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack
  locale: PropTypes.string.isRequired,
  params: PropTypes.shape({}),
  formDocument: PropTypes.shape({}),
};

export const loadModuleData = ({ store: { dispatch } }) => dispatch(loadLanguagePack('axp-iform-renderer', { fallbackLocale: 'en-US' }));

Iform.holocron = {
  name: 'axp-iform-renderer',
  loadModuleData,
};

export default oneAppModuleWrapper('axp-iform-renderer')(Iform);
